import {Body1, Body2, Grid, styled, Subtitle2} from '../../../ui-library';

export const LabelTitle = styled(Subtitle2)`
    color: ${({ theme }) => theme.palette.grey[700]};
    margin-top: 7px;
    text-transform: capitalize;
`;

export const FirstLabelTitle = styled(LabelTitle)`
    margin-top: 0px;
`;
export const ProjectName = styled(Body1)`
    ${({ theme }) => theme.typography.h5};
    color: #000000;
    margin-top: 7px;
`;

export const MetaDataGrid = styled(Grid)`
    margin-top: 24px;
`;

export const BodyText = styled(Body2)`
    color: ${({ theme }) => theme.palette.grey[700]};
`;
